import React, { useEffect, useState } from "react";
import { Link } from "react-router";
import { isValidEmail, isValidName, isValidPhoneNumber } from "./Utils";
import { FACEBOOK_URL, QUERY_FORM_URL, REQUEST_URL, X_URL, YOUTUBE_URL } from "./Config";
import { appListItems } from "./explore_apps/AppList";

function Footer() {

  //email newsletter state
  const [emailDetails, setEmailDetails] = useState({
    emailID: "",
    isValidEmail: false,
  });

  //submit newsletter form button clicked state
  const [submitClicked, setSubmitClicked] = useState(false);
  //contact us form data state
  const [contactUSDetails, setContactUSDetails] = useState({
    customer_name: "",
    customer_email: "",
    customer_phone: "",
    customer_query: "",
  });

  //submit contact us form button clicked state
  const [submitContactUSClicked, setSubmitContactUSClicked] = useState(false);
  //contact us form details validity
  const [contactUSValidity, setContactUSValidity] = useState({
    isValidName: true,
    isValidEmail: true,
    isValidPhoneNumber: true,
    isValidQuery: true,
  });

  //footer configurations
  //set index of app list items for each footer item category
  const itemsDict = {
    PDF_Converter: [3, 4, 6, 7, 8, 9, 10, 33],
    PDF_Manipulation: [13, 20, 21, 23, 24, 25, 27, 28, 46],
    PDF_Transform: [14, 22, 29, 31, 35],
    Image_Converter: [5, 40, 41, 17, 42, 43, 44, 18, 19, 45, 47],
    PDF_Editing: [0, 11, 12, 15, 16, 30, 32, 34, 36],
    Scanner: [37, 38, 39],
  };

  //use effect
  //use effect to handle the submit newsletter button click
  useEffect(() => {
    // If the submit button was clicked
    if (submitClicked === true) {
      //check if valid email id
      if (isValidEmail(emailDetails.emailID)) {
        //api call add to email list
        newsLetterEmailAPI(emailDetails.emailID);

        console.log("Call newsletter api");
      }
    }

    //check if contact us clicked
    if (submitContactUSClicked === true) {
      //set validity
      setContactUSValidity({
        ...contactUSValidity,
        isValidName: isValidName(contactUSDetails.customer_name),
        isValidEmail: isValidEmail(contactUSDetails.customer_email),
        isValidPhoneNumber: isValidPhoneNumber(contactUSDetails.customer_phone),
        isValidQuery:
          contactUSDetails.customer_query.length > 10 ? true : false,
      });

      //check
      if (
        isValidName(contactUSDetails.customer_name) &&
        isValidEmail(contactUSDetails.customer_email) &&
        (contactUSDetails.customer_query.length > 10 ? true : false)
      ) {
        //call api
        queryEmailSubmitAPI();
        //check
        console.log("Call contact us form api");
      } else {
        //rest submit click
        setSubmitContactUSClicked(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitClicked, submitContactUSClicked]);

  //on input newsletter email field changed
  const onInputNewsletterEmailFieldChanged = (e) => {
    //check
    setEmailDetails({
      ...emailDetails,
      isValidEmail: isValidEmail(e.target.value),
      emailID: e.target.value,
    });
  };

  //on contact us form value changed
  const onContactUSFormValueChanged = (e) => {
    //set values
    setContactUSDetails({ ...contactUSDetails, [e.target.id]: e.target.value });
  };

  //submit handler for the form
  const onSubmitNewsletterForm = (event) => {
    // Get the textarea value
    event.preventDefault();
    //set the submit clicked state to true
    //can not access the form values directly here
    //as the state is not updated immediately
    //use effect will be called after the state is updated
    setSubmitClicked(true);
  };

  //submit handler for the form
  const onSubmitContactUSForm = (event) => {
    // Get the textarea value
    //event.preventDefault();
    //set the submit clicked state to true
    //can not access the form values directly here
    //as the state is not updated immediately
    //use effect will be called after the state is updated
    setSubmitContactUSClicked(true);
  };

  //submit query api call
  const queryEmailSubmitAPI = async () => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the humanized text from the API
    await fetch(QUERY_FORM_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        full_name: contactUSDetails.customer_name,
        email_id: contactUSDetails.customer_email,
        phone_number: isValidPhoneNumber(contactUSDetails.customer_phone)
          ? contactUSDetails.customer_phone
          : "",
        query_text: contactUSDetails.customer_query,
      }),
    })
      .then((result) => result.json())
      .then((data) => {
        //check if success
        if (data.success === true) {
          //insert details in database
          contactQueryDetailsSubmitAPI(
            data.email_id,
            data.phone_number,
            data.reference_id,
          );
        } else {
          //reset
          setSubmitContactUSClicked(false);
          //remove text
          setContactUSDetails({
            ...contactUSDetails,
            customer_name: "",
            customer_email: "",
            customer_phone: "",
            customer_query: "",
          });
        }
        console.log("Contact us form submitted: ", data);
      })
      .catch((error) => {
        //reset
        setSubmitContactUSClicked(false);
        //remove text
        setContactUSDetails({
          ...contactUSDetails,
          customer_name: "",
          customer_email: "",
          customer_phone: "",
          customer_query: "",
        });
      });

    console.log("Submit query form");
  };

  //insert query details to db
  const contactQueryDetailsSubmitAPI = async (
    email,
    phone_number,
    reference_id,
  ) => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the humanized text from the API
    await fetch(REQUEST_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "INSERT_CONTACT_US_QUERY_PARAMS",
        email_id: email,
        phone_number: phone_number,
        reference_id: reference_id,
      }),
    })
      .then((result) => result.json())
      .then((data) => {
        //reset
        setSubmitContactUSClicked(false);
        //remove text
        setContactUSDetails({
          ...contactUSDetails,
          customer_name: "",
          customer_email: "",
          customer_phone: "",
          customer_query: "",
        });

        console.log("Successfully pushed details: ", data);
      })
      .catch((error) => {
        //reset
        setSubmitContactUSClicked(false);
        //remove text
        setContactUSDetails({
          ...contactUSDetails,
          customer_name: "",
          customer_email: "",
          customer_phone: "",
          customer_query: "",
        });
      });

    console.log("Submit contact us query details");
  };

  //submit newsletter email api call
  const newsLetterEmailAPI = async (emailID) => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the humanized text from the API
    await fetch(REQUEST_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "SUBMIT_NEWSLETTER_EMAIL",
        email_id: emailID,
      }),
    })
      .then((result) => result.json())
      .then((data) => {
        //reset
        setSubmitClicked(false);
        //remove text
        setEmailDetails({ ...emailDetails, emailID: "", isValidEmail: false });
      })
      .catch((error) => {
        //reset
        setSubmitClicked(false);
        //remove text
        setEmailDetails({ ...emailDetails, emailID: "", isValidEmail: false });
      });

    console.log("Submit newsletter email");
  };

  //return
  return (
    <div>
      <footer className="footer py-3 px-5 bg-light text-dark mt-5 ">
        {/* Footer Bottom */}
        <div className="row mt-5">
          <div className="col-lg-3 text-center"></div>

          {/* Footer Title */}
          <div className="col-lg-6 text-center">
            <div className="text-center">
              <h3 className="text-muted">Shiva PDF</h3>
              <p className="text-muted">
                Your all in one PDF editing tool. Enjoy for free.
              </p>
            </div>

            {/* Footer Links */}
            <div className="container text-center mb-2">
              <Link to="/privacy_policy" className="text-primary mx-2">
                Privacy Policy
              </Link>
              <Link to="/terms_of_service" className="text-primary mx-2">
                Terms of Service
              </Link>
              <Link
                className="text-primary mx-2"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
              >
                Contact us
              </Link>
            </div>

            {/* Social Buttons */}
            <div className="social-footer mt-4">
              {/* Title */}
              <h5 className="fw-bold mb-3">Follow Us</h5>

              <div className="d-flex justify-content-center gap-3 mb-4">
                <a
                  href={FACEBOOK_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-btn facebook"
                  aria-label="Follow Shivapdf on Facebook"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-facebook" viewBox="0 0 16 16">
                    <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
                  </svg>
                </a>

                <a
                  href={YOUTUBE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-btn youtube"
                  aria-label="Subscribe to Shivapdf on YouTube"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-youtube" viewBox="0 0 16 16">
                    <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z" />
                  </svg>
                </a>

                <a
                  href={X_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-btn twitter"
                  aria-label="Follow Shivapdf on X"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                  </svg>
                </a>
              </div>
            </div>

            {/* Copyright Content */}
            <div className="container">
              <p className="text-center text-muted">
                &copy; {new Date().getFullYear()} shivapdf.com | All rights
                reserved.
              </p>
            </div>
          </div>

          {/* Newsletter Signup */}
          <div className="col-lg-3 text-start">
            <h5 className="text-muted mt-4">Subscribe to our Newsletter</h5>
            <form
              className="d-flex justify-content-start"
              onSubmit={onSubmitNewsletterForm}
            >
              <input
                type="email"
                className="form-control me-3 mt-2"
                placeholder="Enter your email"
                onChange={onInputNewsletterEmailFieldChanged}
                value={emailDetails.emailID}
              />
              <button
                type="submit"
                className="btn btn-primary mt-2"
                disabled={
                  emailDetails.isValidEmail === false || submitClicked === true
                }
                onClick={(e) => {
                  //blur
                  e.currentTarget.blur();
                }}
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Apps */}
        {/* Row heading */}
        <div className="row mt-3">
          {/* Converter Title */}
          <div className="col-12 col-md-2 col-sm-4 text-center mt-1">
            {/* Title */}
            <div className="mb-3 mt-0 mt-sm-0">
              <label className="fw-bold-light fs-5">PDF Tools</label>
            </div>

            {/* display all apps */}
            {appListItems
              .filter((item) => itemsDict.PDF_Converter.includes(item.id))
              .map((appItem, index) => (
                <div className="mt-1" key={index}>
                  <Link
                    to={appItem.navigate}
                    state={appItem.state}
                    className="fs-6 text-secondary"
                    style={{ cursor: "pointer", textDecoration: "none", display: "inline-block" }}
                  >
                    {appItem.name}
                  </Link>
                </div>
              ))}
          </div>

          {/* manipulate Title */}
          <div className="col-12 col-md-2 col-sm-4 text-center mt-1">
            {/* Title */}
            <div className="mb-3 mt-5 mt-sm-0">
              <label className="fw-bold-light fs-5">Manipulate</label>
            </div>

            {/* display all apps */}
            {appListItems
              .filter((item) => itemsDict.PDF_Manipulation.includes(item.id))
              .map((appItem, index) => (
                <div className="mt-1" key={index}>
                  <Link
                    to={appItem.navigate}
                    state={appItem.state}
                    className="fs-6 text-secondary"
                    style={{ cursor: "pointer", textDecoration: "none", display: "inline-block" }}
                  >
                    {appItem.name}
                  </Link>
                </div>
              ))}
          </div>

          {/* transform Title */}
          <div className="col-12 col-md-2 col-sm-4 text-center mt-1">
            {/* Title */}
            <div className="mb-3 mt-5 mt-sm-0">
              <label className="fw-bold-light fs-5">Transform</label>
            </div>

            {/* display all apps */}
            {appListItems
              .filter((item) => itemsDict.PDF_Transform.includes(item.id))
              .map((appItem, index) => (
                <div className="mt-1" key={index}>
                  <Link
                    to={appItem.navigate}
                    state={appItem.state}
                    className="fs-6 text-secondary"
                    style={{ cursor: "pointer", textDecoration: "none", display: "inline-block" }}
                  >
                    {appItem.name}
                  </Link>
                </div>
              ))}
          </div>

          {/* image converter Title */}
          <div className="col-12 col-md-2 col-sm-4 text-center mt-1">
            {/* Title */}
            <div className="mb-3 mt-5 mt-sm-0">
              <label className="fw-bold-light fs-5">Image Tools</label>
            </div>

            {/* display all apps */}
            {appListItems
              .filter((item) => itemsDict.Image_Converter.includes(item.id))
              .map((appItem, index) => (
                <div className="mt-1" key={index}>
                  <Link
                    to={appItem.navigate}
                    state={appItem.state}
                    className="fs-6 text-secondary"
                    style={{ cursor: "pointer", textDecoration: "none", display: "inline-block" }}
                  >
                    {appItem.name}
                  </Link>
                </div>
              ))}
          </div>

          {/* editing Title */}
          <div className="col-12 col-md-2 col-sm-4 text-center mt-1">
            {/* Title */}
            <div className="mb-3 mt-5 mt-sm-0">
              <label className="fw-bold-light fs-5">Editing</label>
            </div>

            {/* display all apps */}
            {appListItems
              .filter((item) => itemsDict.PDF_Editing.includes(item.id))
              .map((appItem, index) => (
                <div className="mt-1" key={index}>
                  <Link
                    to={appItem.navigate}
                    state={appItem.state}
                    className="fs-6 text-secondary"
                    style={{ cursor: "pointer", textDecoration: "none", display: "inline-block" }}
                  >
                    {appItem.name}
                  </Link>
                </div>
              ))}
          </div>

          {/* Scanner Title */}
          <div className="col-12 col-md-2 col-sm-4 text-center mt-1">
            {/* Title */}
            <div className="mb-3 mt-5 mt-sm-0">
              <label className="fw-bold-light fs-5">Scanner</label>
            </div>

            {/* display all apps */}
            {appListItems
              .filter((item) => itemsDict.Scanner.includes(item.id))
              .map((appItem, index) => (
                <div className="mt-1" key={index}>
                  <Link
                    to={appItem.navigate}
                    state={appItem.state}
                    className="fs-6 text-secondary"
                    style={{ cursor: "pointer", textDecoration: "none", display: "inline-block" }}
                  >
                    {appItem.name}
                  </Link>
                </div>
              ))}
          </div>
        </div>
      </footer>

      {/* Contact US Modal */}
      <div
        className="modal fade modal-fullscreen-lg-down"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h2 className="modal-title fs-5" id="exampleModalLabel">
                Connect with Us
              </h2>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {/* Full name */}
              <div className="mb-3">
                <label htmlFor="customer_name" className="form-label">
                  Full Name
                </label>
                <input
                  type="text"
                  className={`form-control ${contactUSValidity.isValidName ? "" : "border-danger"
                    }`}
                  id="customer_name"
                  placeholder="Alex Finch"
                  onChange={onContactUSFormValueChanged}
                  value={contactUSDetails.customer_name}
                />
              </div>

              {/* Email Address */}
              <div className="mb-3">
                <label htmlFor="customer_email" className="form-label">
                  Email address
                </label>
                <input
                  type="email"
                  className={`form-control ${contactUSValidity.isValidEmail ? "" : "border-danger"
                    }`}
                  id="customer_email"
                  placeholder="alex123@gmail.com"
                  onChange={onContactUSFormValueChanged}
                  value={contactUSDetails.customer_email}
                />
              </div>

              {/* Phone number */}
              <div className="mb-3">
                <label htmlFor="customer_phone" className="form-label">
                  Phone number (optional)
                </label>
                <input
                  type="phone"
                  className="form-control"
                  id="customer_phone"
                  placeholder="+1-123-567-9870"
                  onChange={onContactUSFormValueChanged}
                  value={contactUSDetails.customer_phone}
                />
              </div>

              {/* Query */}
              <div className="mb-3">
                <label htmlFor="customer_query" className="form-label">
                  What do you have in mind?
                </label>
                <textarea
                  type="text"
                  className={`form-control ${contactUSValidity.isValidQuery ? "" : "border-danger"
                    }`}
                  id="customer_query"
                  placeholder="Please enter query"
                  rows="3"
                  onChange={onContactUSFormValueChanged}
                  value={contactUSDetails.customer_query}
                ></textarea>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={(e) => {
                  //blur
                  e.currentTarget.blur();
                  //call
                  onSubmitContactUSForm();
                }}
                disabled={submitContactUSClicked}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
